<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { tw } from "@core/utils/svelte/tw.js";
	import { MembershipBenefitCardVariant } from "./MembershipBenefitCardVariant.js";

	const {
		title,
		subheading,
		benefits,
		button,
		variant,
		class: customClass,
	}: {
		title: string;
		subheading?: string;
		benefits: string[];
		button?: Snippet;
		variant: MembershipBenefitCardVariant;
		class?: ClassValue;
	} = $props();

	const variantStyles: Record<MembershipBenefitCardVariant, ClassValue> = {
		[MembershipBenefitCardVariant.White]: tw("bg-fcrbeige text-fcrdarkgray"),
		[MembershipBenefitCardVariant.Brown]: tw("bg-[#AD6939] text-white"),
		[MembershipBenefitCardVariant.Blue]: tw("bg-[#2A4376] text-white"),
	};
</script>

<article
	class={[
		"p-10 h-110 rounded-[20px] flex flex-col max-w-102 w-full md:max-w-86 lg:max-w-94 xl:max-w-102",
		variantStyles[variant],
		customClass,
	]}
>
	<h2 class="font-antipol font-bold text-9/tighter min-h-16 my-1 text-center whitespace-break-spaces">
		{title}
	</h2>
	{#if subheading}
		<h3 class="font-antipol text-center uppercase mt-5">
			{subheading}
		</h3>
	{/if}
	<ul class="list-disc pl-8 my-auto">
		{#each benefits as benefit, index (index)}
			<li><Formatted text={benefit} /></li>
		{/each}
	</ul>

	{@render button?.()}
</article>
